export function Stat({
  label,
  value,
  sub,
}: {
  label: string;
  value: string | number;
  sub?: string;
}) {
  return (
    <div className="panel flex min-w-[9rem] flex-1 flex-col gap-1 p-4">
      <span className="eyebrow">{label}</span>
      <span className="tabular text-stat">{value}</span>
      {sub && <span className="text-caption text-leaf-soft">{sub}</span>}
    </div>
  );
}

export function StatStrip({ children }: { children: React.ReactNode }) {
  return <div className="flex flex-wrap gap-3">{children}</div>;
}

/**
 * A number that leads the page, as opposed to one of a row of equals.
 *
 * The guest list had seven `Stat` panels of identical weight, which is the same
 * as having none: nothing was answered first. Two of those numbers are the ones
 * anybody actually acts on — what the caterer cooks, and what the venue has to
 * hold — so they get the size and the rest become a supporting line.
 */
export function Metric({
  label,
  value,
  sub,
}: {
  label: string;
  value: string | number;
  sub?: string;
}) {
  return (
    <div className="flex min-w-[10rem] flex-1 flex-col gap-1">
      <span className="eyebrow">{label}</span>
      <span className="tabular font-display text-[44px] font-light leading-none text-leaf">
        {value}
      </span>
      {sub && <span className="text-caption text-leaf-soft">{sub}</span>}
    </div>
  );
}

/** The small facts under a `Metric`, separated by dots rather than boxed. */
export function MetricFootnote({ items }: { items: (string | false | undefined)[] }) {
  const shown = items.filter((x): x is string => Boolean(x));
  return (
    <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-caption text-leaf-soft">
      {shown.map((item, i) => (
        <span key={item} className="flex items-center gap-2">
          {i > 0 && (
            <span aria-hidden="true" className="text-line">
              &middot;
            </span>
          )}
          <span className="tabular">{item}</span>
        </span>
      ))}
    </p>
  );
}
